import {
    DIC
} from '@/const/dic'
import {baseUrl} from '@/config/env';


export const pointsTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    labelWidth: '120',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "请输入员工编码",
            prop: "code",
            search: true,
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            hide: true,
        }, {
            label: "请输入员工名称",
            prop: "name",
            type: 'input',
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay: false,
            hide: true,
        },{
            label: "员工编码",
            prop: "stuffCode",
            type: "input"
        }, {
            label: "员工名称",
            prop: "stuffName",
            type: 'input',
        },
        {
            label: "部门名称",
            prop: "departName",
            type: "input"
        },
        {
            label: "员工积分",
            prop: "points",
            type: "input"
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            hide: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.STATUS_STATE_MODEL
        // },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            span: 24,
            hide: true,
            max: 255
        }


    ]
};